import {Component, Mixins} from "vue-property-decorator";
import {accountActivation, resetPassword} from "~/modules/auth/service";
import {ChangePasswordStep} from "~/modules/auth/components/change-password-step";

@Component
class SignUpPasswordStep extends Mixins(ChangePasswordStep) {
  protected async sendRequest() {
    await accountActivation({
      code: this.code,
      password: this.nextPassword
    });
  }
}

export {SignUpPasswordStep}

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-51b36bf4/signup-password-step.tsx" });